import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  class ModeloService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
  
      this.url = env.url + "template-tarefa";
      
      this.controladoresDeInstancia = {
        listar: new AbortController(),
        cadastrar: new AbortController(),
        editar: new AbortController(),
      }
    }
  
    async listar(objetoDeFiltros, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
      return super.get(`${this.url}` + queryString, this.controladoresDeInstancia.listar);
    }

    async listarTodos(objetoDeFiltros, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      objetoDeFiltros.pagina = 1;

      let modelos = [];
      let totalDePaginas;
      
      do {
        const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
        const fullUrl = `${this.url}` + queryString;

        const response = await this.get(fullUrl, controlador);
        modelos = modelos.concat(response.data);
        totalDePaginas = parseInt(response.totalDePaginas);
        objetoDeFiltros.pagina ++;
      } while (objetoDeFiltros.pagina <= totalDePaginas);

      return modelos;
    }

    async cadastrar(modelo, controlador) {
      this.controladoresDeInstancia.cadastrar = this.selecionarControlador(controlador);
      const response = await super.post(this.url, modelo, this.controladoresDeInstancia.cadastrar);
      if (response.ok) {
          return response;
      } else {
          toastUtils.dangerToast("Não foi possível cadastrar modelo.");
          throw new Error('HTTP ' + response.status);
      }
    }

    async editar(modelo, controlador) {
      this.controladoresDeInstancia.editar = this.selecionarControlador(controlador);
      const response = await super.patch(this.url, modelo, this.controladoresDeInstancia.editar);
      if (response.ok) {
          return response;
      } else {
          toastUtils.dangerToast("Não foi possível editar o comentário");
          throw new Error('HTTP ' + response.status);
      }
    }

    async apagar(id, controlador) {
      if (!id) {
        console.warn('WARN: Objeto não pode ser apagado pois não possui id;');
      } else {
        let url = `${this.url}`;
        return await this.delete(url, id, controlador);
      }
    }
  }
  
  export const modeloService = new ModeloService()
  